export default __webpack_public_path__ + "assets/webgl/scene-18.5cde4b44.glb";